export const SIMULATIONID = 'SIMULATION-ID';
export const AMORTIZATIONCALCULATORDATA = 'AMORTIZATIONCALCULATORDATA';
export const PREVIOUSPAGE = 'PREVIOUSPAGE';
